/**
 * Category names on the starter task catalog (public.tasks where agent_id is null).
 * Super Admin template editors use this list. Vendor trades are a different list.
 */

const TASK_CATEGORIES = [
  'Appliances',
  'Electrical',
  'Exterior',
  'Exterior Hardscape',
  'Financial & Administrative',
  'Foundation',
  'Garage',
  'Gutters & Drainage',
  'HVAC',
  'Interior',
  'Irrigation',
  'Landscape',
  'Pest Control',
  'Plumbing',
  'Pool',
  'Roof',
  'Safety',
  'Septic',
  'Solar',
  'Well & Water Treatment',
  'Windows & Doors',
];

const FREQUENCY_OPTIONS = [
  'Weekly',
  'Monthly',
  'Quarterly',
  'Semiannually',
  'Annually',
  'Every 2 Years',
  'Every 3 Years',
  'Every 4 Years',
  'Every 5 Years',
  'Every 7 Years',
  'Every 12 Years',
];

const SEASON_OPTIONS = [
  'Spring',
  'Summer',
  'Fall',
  'Winter',
  'Hurricane season',
  'Heating season',
  'Cooling season',
  'One time',
];

function categoryChoices(rows) {
  const names = TASK_CATEGORIES.slice();
  const seen = new Set(names.map((name) => name.toLowerCase()));
  (rows || []).forEach((row) => {
    const name = String((row && row.category) || '').trim();
    const key = name.toLowerCase();
    if (!name || seen.has(key)) return;
    seen.add(key);
    names.push(name);
  });
  names.sort((left, right) => left.localeCompare(right, undefined, { sensitivity: 'base' }));
  return names;
}

module.exports = {
  TASK_CATEGORIES,
  FREQUENCY_OPTIONS,
  SEASON_OPTIONS,
  categoryChoices,
};
